import { createContext } from "react";
import type { Mode } from "~/features/cart/cart/models/QuoteData";

type SetActiveQuotePageMode = (mode: Mode) => void;

export const ActiveQuotePageModeContext = createContext<SetActiveQuotePageMode>(() => {
  throw Error("Not supported");
});
